<ng-container [ngSwitch]="true">
    <ng-container *ngSwitchCase="filter.matchMode == 'equals' || filter.matchMode == 'contains'">
        <input pInputText type="text" placeholder="{{filter.label | translate}}"
               (input)="filterTable($event.target.value,filter.matchMode)"/>
    </ng-container>
    <ng-container *ngSwitchCase="filter.matchMode == 'gt' || filter.matchMode == 'lt' || filter.matchMode == 'gte' || filter.matchMode == 'lte'">
        <div class="ui-inputgroup">
            <p-dropdown [options]="operators" [(ngModel)]="filter.matchMode"
                        (onChange)="filterTable(input.value, filter.matchMode)">
            </p-dropdown>
            <input pInputText type="text" placeholder="{{filter.label | translate}}" #input
                   style="width: 100%"
                   (input)="filterTable(input.value, filter.matchMode)"/>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="filter.matchMode == 'multi'">
        <ng-select
            #multi
            class="select-custom"
            [items]="data"
            [dropdownPosition]="'bottom'"
            [multiple]="true"
            bindLabel="label"
            [closeOnSelect]="false"
            bindValue="value"
            [notFoundText]="'Gösterilecek data yok' | translate"
            (change)="selectChange($event)"
            (clear)="clearSelect($event)"
            [clearSearchOnAdd]="true" placeholder="{{filter.label | translate}}"
            [(ngModel)]="multiSelected"
            [virtualScroll]="true"
            [bufferAmount]="300"
            [appendTo]="'body'">
            <ng-template ng-header-tmp>
                <p-checkbox (click)="toggleSelectAll()" binary="true"></p-checkbox>
            </ng-template>
            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                <ng-container *ngIf="items.length > 2">
                    <div class="ng-value">
                        <span class="ng-value-label">{{items.length}} {{'seçili...' | translate}}</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="items.length <= 2">
                    <div class="ng-value" *ngFor="let item of (items ? items.slice(0,2): [])">
                        <span class="ng-value-label">{{item.label | translate}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </div>
                </ng-container>
            </ng-template>

            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <p-checkbox [ngModel]="item$.selected" binary="true" id="item-{{index}}"></p-checkbox>
                <span
                    [ngClass]="{
                        'pending': filter?.field === 'status' && filter?.join === 'coupon' && item?.value === 0,
                        'won': filter?.field === 'status' && filter?.join === 'coupon' && item?.value === 1,
                        'lost': filter?.field === 'status' && filter?.join === 'coupon' && item?.value === -1,
                        'cancel': filter?.field === 'status' && filter?.join === 'coupon' && item?.value === 2,
                        'sold': filter?.field === 'status' && filter?.join === 'coupon' && item?.value === 3
                    }"
                >
                    {{item.label | translate}}
                </span>
            </ng-template>
        </ng-select>

    </ng-container>
    <ng-container *ngSwitchCase="filter.matchMode == 'single'">
        <ng-select
            class="select-custom"
            [dropdownPosition]="'bottom'"
            [items]="data"
            bindLabel="label"
            bindValue="value"
            [notFoundText]="'Gösterilecek data yok' | translate"
            (change)="filterTable($event?.value,'equals')"
            placeholder="{{filter.label | translate}}"
            [(ngModel)]="multiSelected"
            [virtualScroll]="false"
            [appendTo]="'body'">
            <ng-template ng-label-tmp let-item="item">
                <span class="ng-value-label">{{item.label | translate}}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                {{item.label | translate}}
            </ng-template>
        </ng-select>
    </ng-container>
    <ng-container *ngSwitchCase="filter.matchMode == 'dateRange'">
        <p-calendar selectionMode="range"
                    placeholder="{{filter.label | translate}}"
                    [style.width.%]="100"
                    dateFormat="yy-mm-dd" [monthNavigator]="true" [showButtonBar]="true" [yearNavigator]="true"
                    [showIcon]="true"
                    [yearRange]="yearRange"
                    [(ngModel)]="rangeDates"
                    [selectOtherMonths]="true"
                    [maxDate]="maxDate"
                    dataType="string"
                    [showTime]="true"
                    [showSeconds]="true"
                    [hourFormat]="24"
                    [readonlyInput]="true"
                    [appendTo]="'body'"
                    panelStyleClass="calendar-below"
                    (onSelect)="filterTable(rangeDates,'dateRange')"
                    (onClearClick)="filterTable('','dateRange')"></p-calendar>
    </ng-container>
    <ng-container *ngSwitchCase="filter.matchMode == 'date'">
        <p-calendar
            placeholder="{{filter.label | translate}}"
            [style.width.%]="100"
            dateFormat="yy-mm-dd"
            [monthNavigator]="true"
            [showButtonBar]="true"
            [yearNavigator]="true"
            [showIcon]="true"
            [yearRange]="yearRange"
            [(ngModel)]="singleDateTime"
            [selectOtherMonths]="true"
            [maxDate]="maxDate"
            dataType="string"
            [readonlyInput]="true"
            [appendTo]="'body'"
            panelStyleClass="calendar-below"
            (onSelect)="filterDate(singleDateTime)"
            (onClearClick)="filterDate(null)"></p-calendar>
    </ng-container>
    <ng-container *ngSwitchCase="filter.matchMode == 'dateTimeFrom' || filter.matchMode == 'dateTimeTo'">
        <p-calendar
            placeholder="{{filter.label | translate}}"
            [style.width.%]="100"
            dateFormat="yy-mm-dd"
            [monthNavigator]="true"
            [showButtonBar]="true"
            [yearNavigator]="true"
            [showIcon]="true"
            [yearRange]="yearRange"
            [(ngModel)]="singleDateTime"
            [selectOtherMonths]="true"
            [maxDate]="maxDate"
            dataType="string"
            [showTime]="true"
            [showSeconds]="true"
            [hourFormat]="24"
            [readonlyInput]="true"
            [appendTo]="'body'"
            panelStyleClass="calendar-below"
            (onSelect)="filterDateTime(singleDateTime, filter.matchMode)"
            (onClearClick)="clearDateTime(filter.matchMode)"></p-calendar>
    </ng-container>
    <ng-container *ngSwitchCase="filter.matchMode == 'range'">
        <div class="range-filter">
            <input pInputText type="number" step="any" inputmode="decimal" [placeholder]="getFromPlaceholder()" #fromInput
                   style="width: 48%"
                   (input)="filterRange(fromInput.value, toInput.value)"/>
            <input pInputText type="number" step="any" inputmode="decimal" [placeholder]="getToPlaceholder()" #toInput
                   style="width: 48%"
                   (input)="filterRange(fromInput.value, toInput.value)"/>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="filter.matchMode == 'quickDate'">
        <div class="quick-date-wrapper">
            <div class="quick-date-toggle" (click)="qop.toggle($event)">
                <i class="pi pi-calendar"></i>
                <span class="quick-date-toggle__label"
                      [class.placeholder]="!quickDatePreset && !quickDateCustomFrom">{{ quickDateLabel | translate }}</span>
                <i class="pi pi-times quick-date-toggle__clear"
                   *ngIf="quickDatePreset || quickDateCustomFrom"
                   (click)="$event.stopPropagation(); clearQuickDate()"></i>
                <i class="pi pi-chevron-down quick-date-toggle__chevron"></i>
            </div>
            <p-overlayPanel #qop [appendTo]="'body'" styleClass="quick-date-panel" [dismissable]="true">
                <div class="quick-date-presets">
                    <button *ngFor="let p of quickDatePresets"
                            class="quick-preset-btn"
                            [class.active]="quickDatePreset === p.value"
                            (click)="selectQuickPreset(p.value, qop)">
                        {{ p.label | translate }}
                    </button>
                </div>
                <div class="quick-date-divider"></div>
                <div class="quick-date-custom">
                    <div class="quick-date-custom__row">
                        <p-calendar [(ngModel)]="quickDateCustomFrom"
                                    dateFormat="yy-mm-dd"
                                    [maxDate]="quickDateMaxDate"
                                    [monthNavigator]="true"
                                    [yearNavigator]="true"
                                    yearRange="1970:2030"
                                    [showIcon]="true"
                                    placeholder="{{'From' | translate}}"
                                    (onSelect)="onQuickFromSelect()">
                        </p-calendar>
                        <p-calendar [(ngModel)]="quickDateCustomFromTime"
                                    [timeOnly]="true"
                                    [showSeconds]="true"
                                    [hourFormat]="'24'"
                                    [showIcon]="true"
                                    placeholder="00:00:00"
                                    styleClass="quick-time-picker">
                        </p-calendar>
                    </div>
                    <div class="quick-date-custom__row">
                        <p-calendar [(ngModel)]="quickDateCustomTo"
                                    dateFormat="yy-mm-dd"
                                    [maxDate]="quickDateMaxDate"
                                    [monthNavigator]="true"
                                    [yearNavigator]="true"
                                    yearRange="1970:2030"
                                    [showIcon]="true"
                                    placeholder="{{'To' | translate}}"
                                    (onSelect)="onQuickToSelect()">
                        </p-calendar>
                        <p-calendar [(ngModel)]="quickDateCustomToTime"
                                    [timeOnly]="true"
                                    [showSeconds]="true"
                                    [hourFormat]="'24'"
                                    [showIcon]="true"
                                    placeholder="23:59:59"
                                    styleClass="quick-time-picker">
                        </p-calendar>
                    </div>
                    <div class="quick-date-actions">
                        <button pButton
                                class="p-button-sm p-button-secondary quick-date-clear"
                                label="{{'Clear' | translate}}"
                                (click)="clearQuickDate(); qop.hide()">
                        </button>
                        <button pButton
                                class="p-button-sm quick-date-apply"
                                label="{{'Apply' | translate}}"
                                [disabled]="!quickDateCustomFrom || !quickDateCustomTo"
                                (click)="applyQuickCustom(qop)">
                        </button>
                    </div>
                </div>
            </p-overlayPanel>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="filter.matchMode == 'refresh'">
        <button pButton [icon]="'fas fa-fw fa-sync-alt'" [iconPos]="'left'" (click)="table.filter(null,null,null)"></button>
    </ng-container>
</ng-container>
